module.exports = __webpack_public_path__ + "static/media/20ECE30.dd3cbe9b.jpg";